export default "__VITE_ASSET__DD5UjH2p__"